module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('section', {
    staticClass: "mdl-layout__tab-panel is-active",
    attrs: {
      "id": "scroll-tab-1"
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-400fa7b1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiContent.vue
// module id = 270
// module chunks = 2